import React from 'react'
import PropTypes from 'prop-types'
import styles from './ProfileLeftSidebar.module.scss'

// left sidebar slot
export default function ProfileLeftSidebar({ children }) {
  return <aside className={styles.sidebar}>{children}</aside>
}

ProfileLeftSidebar.propTypes = {
  children: PropTypes.node,
}
